/**
 * CUSTOMIZATIONS:
 * moved main foooter in FooterMain component
 * added FooterInfo, FooterSmall and SocialLinks
 **/

/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React, { useMemo } from 'react';
import { Container, Segment } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import cx from 'classnames';

import {
  FooterInfo,
  FooterSmall,
  FooterMain,
} from '@redturtle/volto-io-studio/components/Layout';
import { SocialLinks } from 'volto-social-settings';

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = (props) => {
  const navroot = useSelector((state) => state.navroot);

  const subsite_social_links = useMemo(() => {
    const links = navroot?.data?.navroot?.subsite_social_links;
    return typeof links == 'string' ? JSON.parse(links) : links || [];
  }, [navroot?.data?.navroot?.subsite_social_links]);
  const wrapperCssClass = undefined;
  const itemCssClass = undefined;
  return (
    <footer>
      <FooterInfo />
      <Segment vertical id="footer">
        <Container>
          <FooterMain />
          {subsite_social_links.length > 0 ? (
            <div className={cx('social-header', wrapperCssClass)}>
              {subsite_social_links.map((social) => {
                const { title, icon, url } = social;
                return (
                  <a
                    href={url}
                    rel="noopener noreferrer"
                    className={cx(itemCssClass)}
                    target="_blank"
                    title={title}
                    key={url}
                  >
                    <Icon name={icon} />
                  </a>
                );
              })}
            </div>
          ) : (
            <SocialLinks />
          )}
        </Container>
      </Segment>
      <FooterSmall />
    </footer>
  );
};

export default Footer;
